import React, { useEffect, useState } from 'react'
import { Col, Row, Input, Select, Menu, Space, Button, Typography } from 'antd'
import { SearchOutlined, DownOutlined } from '@ant-design/icons'
import './templates.css'
import TemplateCard from '../TemplateCard/templateCard'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from "react-router-dom";
import { getJobTemplates } from '../../../../../redux/actions'

const Templates = () => {
    const { Option } = Select;

    const location = useLocation();
    const { Text } = Typography;
    const dispatch = useDispatch();
    const [selected, setSelected] = React.useState();
    const [templates,setTemplates] = useState([]);
    const [searchtext, setSearch] = React.useState();
    const [inputText, setInputText] = React.useState();



    const jobs = useSelector(state => state.postJObReeducer.jobs);

    useEffect(() => {
        // setTemplates(jobs);
        setSearch(jobs);
    }, [jobs]);

    const getSelectValue = (e) => {
        setSelected(e);
        setSearch(null);
        setInputText(null);
        // dispatch(getJobTemplates(e))
        dispatch(getJobTemplates({ type: e.toLowerCase(), JobOrderTypeName: location.state.PermanentJob ? 'Permanent' : 'Contract' }))
    }

    const getSearchText = (e) => {
        setInputText(e.target.value);
        var search = jobs.filter(item =>
            item.Title.toLowerCase().includes(
                e.target.value.toLowerCase()
            )
        )
        setSearch(search)
    }
    return (
        <>
            <Col className='the-templates'>
                <div className='temp-header'>
                    Choose from templates
                </div>
                <Row>
                    <Col xs={16} lg={11}>
                        <Input type={'input'} value={inputText} allowClear className="temp-input" onChange={getSearchText}
                            placeholder='Search template' prefix={<SearchOutlined className='Search-icon' />} />
                    </Col>

                    <Col className='dropdown' xs={8} lg={4}>
                        <Select defaultValue="Saved" disabled onChange={getSelectValue} popupClassName='select choose-template-type-select'    style={{
          width: 100,
        }}>
                            {/* <Option value={'Default'}>Default</Option> */}
                            {/* <Option value={'All'}>All</Option> */}
                            <Option value={'Saved'}>Saved</Option>
                        </Select>
                    </Col>
                </Row>
                <Row className='template-cards-container'>
                    {searchtext?.length ? searchtext.map((items, index) => {
                        return <TemplateCard {...items} key={index} _id={items?.JobOrderId} tag={selected} />
                    })
                        // : jobs.length ?
                        // jobs.map((items) => {
                        //     return <TemplateCard {...items} tag={selected} />
                        // })
                            : <TemplateCard empty='empty' />
                    }
                </Row>
            </Col>
        </>
    )
}
export default Templates